import {hc} from 'hono/client';
import type {ApiType} from '../../server/routes/api/app-type.ts';
import {getAuthToken} from '../lib/storage.ts';

const baseUrl = '/api';

// Create type-safe RPC client
// In dev: /api is proxied by Vite to Hono server
// In prod: /api is served directly by Hono
export const api = hc<ApiType>(baseUrl, {
	headers: () => ({
		Authorization: `Bearer ${getAuthToken()}`
	})
});
